import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { SnackbarProvider, useSnackbar } from 'notistack';

function MyApp({ notification }) {
  const { message, variant } = notification;
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (message) enqueueSnackbar(message, { variant });
  });

  return null;
}

function IntegrationNotistack({ notification }) {
  return (
    <SnackbarProvider maxSnack={3}>
      <MyApp notification={notification} />
    </SnackbarProvider>
  );
}

const mapStateToProps = state => ({
  notification: state.notification
});

export default connect(
  mapStateToProps,
  null
)(IntegrationNotistack);
